export enum PaymentProviders {
  STRIPE = 'stripe',
  SUBSTRATE = 'substrate',
  ETHER = 'ether',
}
